export default "__VITE_ASSET__CGXPucqj__"